import { PropertyStripLayout } from "../../../canvas/properties/PropertyStripLayout";
import { AutoLayoutConfigWidget } from "../../autoLayout/AutoLayoutConfigWidget";
import { frameEditAddonDimensions } from "./FrameAddonDimensionCommands";
import { TimelineFrameAddon } from "./TimelineFrameAddon";
import { TimelineFrameAddonDateWidget } from "./TimelineFrameAddonDateWidget";
import { TimelineFrameAddonSettingsWidget } from "./TimelineFrameAddonSettingsWidget";

export const TimelineFrameAddonPropertyLayout = PropertyStripLayout<TimelineFrameAddon>((d, s, o, w, a) => {
    return [
        // Color
        w.createColorSelector({
            autoSelect: true,
            groups: true,
            value: a.get('color'),
            text: 'Header Color',
            onSelect() {
                o.update(u => {
                    u.rolling(a.keyFor('color'));
                    a.set('color', this.value!)
                });
            }
        }),
        // Date Range
        w.createPopout({
            text: 'Start Date',
            image: 'deqo://icons/i8/date-from@[1.125,1.125,0]',
            value: a.get('from') || new Date(),
            ui: TimelineFrameAddonDateWidget,
            onSelect() {
                o.update(u => {
                    u.rolling(a.keyFor('from'));
                    a.set('from', this.value ?? new Date());
                });
            }
        }),
        // Grid Dimensions
        w.createButton({
            text: 'Timeline Dimensions',
            image: 'deqo://icons/d2/grid-settings',
            onAction() {
                d(frameEditAddonDimensions, [a.first()?.id]);
            }
        }),
        // Calendar Settings
        w.createPopout({
            text: 'Timeline Headers',
            image: 'deqo://icons/d2/grid-headers',
            value: a.get('headers'),
            ui: TimelineFrameAddonSettingsWidget,
            onSelect() {
                o.update(u => a.set('headers', this.value!));
            }
        }),
        w.createPopout({
            image: 'deqo://icons/d2/flex',
            text: 'Layout Mode',
            ui: AutoLayoutConfigWidget,
            value: a.get('layoutMode'),
            onSelect() {
                o.update(u => {
                    u.rolling(a.keyFor('layoutMode'));
                    a.set('layoutMode', this.value!);
                });
            }
        }),

    ]
});